__turbopack_context__.v({
  "className": "sfprodisplay_fe27d042-module__K4iBPG__className",
  "variable": "sfprodisplay_fe27d042-module__K4iBPG__variable",
});
